import {  Box, Image  } from '@chakra-ui/react'
import React from 'react'

function Footer() {
  return (
    <Box w='1200px' ml='200px'>
    <Image  mt='20px' src="https://www.kindmeal.my/images/media-feature2.png"></Image >
      <Image mt='20px' src='https://www.kindmeal.my/images/banner_whykindmeal.png'></Image >
    </Box>
  )
}

export default Footer
